const SEARCH_DEBOUNCE_MS = 300;

export { SEARCH_DEBOUNCE_MS };

export function ensureItemsModalState(context) {
    if (!context.itemsModalState) {
        context.itemsModalState = {
            items: [],
            filteredItems: [],
            selectedIds: new Set(),
            searchTerm: '',
            searchTimer: null,
            cachedElements: [],
            collection: null,
            isBulkDeleting: false,
            eventsInitialized: false,
        };
    }

    return context.itemsModalState;
}

export function clearSearchTimer(state) {
    if (state.searchTimer) {
        clearTimeout(state.searchTimer);
        state.searchTimer = null;
    }
}

export function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function disableVisibleCheckboxes(disabled) {
    document.querySelectorAll('#items-list .item-checkbox').forEach((checkbox) => {
        checkbox.disabled = disabled;
    });
}
